/** Pide la ubicación con watchPosition en vez de una sola lectura: en Android, sobre todo en
 * equipos más viejos, el primer fix de GPS suele ser el peor (o resuelve por red/celda si no se
 * pide enableHighAccuracy). Nos quedamos con la lectura de menor accuracy hasta que llegue una
 * "suficientemente buena" o se acabe la ventana de espera. */
export function getBestGeoFix({ onUpdate, maxWaitMs = 12000, goodEnoughAccuracy = 30 } = {}) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    let best = null;
    let watchId = null;
    let done = false;

    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      if (watchId != null) navigator.geolocation.clearWatch(watchId);
      resolve(best);
    };

    const timer = setTimeout(finish, maxWaitMs);

    watchId = navigator.geolocation.watchPosition(
      (pos) => {
        if (!best || pos.coords.accuracy < best.coords.accuracy) {
          best = pos;
          onUpdate?.(pos.coords.accuracy);
        }
        if (pos.coords.accuracy <= goodEnoughAccuracy) finish();
      },
      () => {}, // ignora errores puntuales; seguimos esperando hasta el timeout
      { enableHighAccuracy: true, maximumAge: 0, timeout: maxWaitMs },
    );
  });
}
